import axios from 'axios'
import autenticacao from '@/shared/services/autenticacao'
import loading from '@/shared/plugins/loading'
import { formataUrlRedirecionamento } from '@/shared/common/functions/roteamento'
import { salvaMensagem } from '@/shared/common/functions/mensagens'
import Vue from 'vue'

const baseURL = process.env.VUE_APP_API_CTE_URL || 'https://cte.beteltecnologia.net/api/'
const token = autenticacao.pegaToken()
export const $api = {
    
    headers: {
        'x-token-auth': token || '',
        'host-origin': window.location.host,
        'Content-Type': 'application/json'
    },

    async axios(
        url, 
        params = null, 
        method = 'get', 
        _baseURL = baseURL,
        headers = this.headers
    ){
        const _axios = axios.create({
            baseURL: _baseURL,
            headers: headers
        })
        _axios.interceptors.response.use(
            (response) => {
                return response
            }
        )
        if(params){
            return await _axios[method](url, params)
        }else{
            return await _axios[method](url)
        }
    },

    async request(
        url, 
        params = {}, 
        load = true, 
        method = 'get',
        responseType = 'json',
        contentType = 'application/json',
        redirect = true
    ){
        if(load){
            loading.show()
        }
        let retorno = {}
        try {
            retorno = await this.axios(
                url, 
                params, 
                method,
                baseURL,
                {
                    'x-token-auth': autenticacao.pegaToken() || '',
                    'host-origin': window.location.host,
                    'Content-Type': contentType
                },
                responseType
            )
        } catch (error) {
            if(error.response){
                retorno = error.response.data
                if (error.response.status == 403) {
                    retorno.code = 403
                    retorno.redirect = '/cte'
                }
            }else if (error.request) {
                retorno = error.request
            } else {
                retorno = error
            }
        }
        if(load){
            loading.hide()
        }
        if(redirect) {
            this.redirect(retorno)
        }
        return retorno
    },

    async get(url, params = {}, load = true) {
        return await this.request(url, {params: params}, load, 'get')
    },

    async post(url, params = {}, load = true) {
        return await this.request(url, params, load, 'post')
    },

    async put(url, params = {}, load = true) {
        return await this.request(url, params, load, 'put')
    },

    async delete(url, params = {}, load = true) {
        return await this.request(url, params, load, 'delete')
    },

    async getBlob(url, params = {}, load = true) {
        return await this.request(url, {params: params}, load, 'get', 'blob', 'blob')
    },

    redirect(res){
        if(res.code && res.redirect){
            if([402, 403].includes(res.code)){
                loading.show()
                const redirect = formataUrlRedirecionamento(res.redirect)
                let url = redirect
                //se redirecionado para meu_plano e existe mensagem, passa a mensagem para o componente via query para exibir a mensagem no <b-alert>
                if(res.redirect.action == 'meu_plano' && res.message){
                    url = url + '?mensagem=' + res.message
                }
                else if(res.message){
                    salvaMensagem(res.message, 'Atenção', 'error')
                }
                window.location.href = url
            }
        }
    }
}

Vue.prototype.$apicte = $api;

export default $api
